import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTeamviewerComponent } from './simple-icons-teamviewer.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTeamviewerComponent ],
    exports:      [ SimpleIconsTeamviewerComponent ],
    bootstrap:    []
})
export class SimpleIconsTeamviewerModule {}
